// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { addBeneficiaryPostChallengeRequest } from 'services/BeneficiaryService'

export const useAddBeneficiaryMutationChallengeRequest = () =>
  useMutation({ mutationFn: addBeneficiaryPostChallengeRequest })
